import { observer } from "mobx-react-lite";
import React from "react";

import { HouseType, IconName } from "../types";
import IconButton from "./IconButton";

const HouseTypeSelector = observer(
  (props: {
    onClick: (houseType: HouseType) => void;
    selected: HouseType | null;
  }) => {
    return (
      <div className={"pyht-house-type-selector"}>
        <IconButton
          active={props.selected === HouseType.SINGLE_STORY}
          icon={IconName.HOUSE_SINGLE_STORY}
          size={"large"}
          highlightStyle={"tick"}
          title={"Single Storey"}
          onClick={() => props.onClick(HouseType.SINGLE_STORY)}
        />
        <IconButton
          active={props.selected === HouseType.DOUBLE_STORY}
          icon={IconName.HOUSE_DOUBLE_STORY}
          size={"large"}
          highlightStyle={"tick"}
          title={"Double Storey"}
          onClick={() => props.onClick(HouseType.DOUBLE_STORY)}
        />
        <IconButton
          active={props.selected === HouseType.ACREAGE}
          icon={IconName.HOUSE_ACREAGE}
          size={"large"}
          highlightStyle={"tick"}
          title={"Acreage"}
          onClick={() => props.onClick(HouseType.ACREAGE)}
        />
      </div>
    );
  }
);

export default HouseTypeSelector;
